"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTextSmall(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm4 4.2951a.29.29 0 0 1 .283-.2951h6.436a.29.29 0 0 1 .2829.2955v1.4065c0 .163-.085.296-.189.296s-.24-.122-.303-.27l-.245-.472a.4716.4716 0 0 0 -.397-.27h-1.6429a.29.29 0 0 0 -.2829.2955v5.634a.4211.4211 0 0 0 .271.38l1.121.186a.3719.3719 0 0 1 .271.3022.2575.2575 0 0 1 -.2831.2163h-3.642a.2575.2575 0 0 1 -.2829-.2173.3719.3719 0 0 1 .271-.3022l1.043-.186a.421.421 0 0 0 .271-.38v-5.6345a.29.29 0 0 0 -.2821-.2956h-1.565a.4717.4717 0 0 0 -.397.2706l-.245.472c-.063.149-.199.271-.303.271s-.19-.134-.19-.296v-1.407' })));
}
exports.default = SvgTextSmall;
